import { Link } from "react-router-dom";
import Logo from "../../assets/logo.png";
import { PATH } from "../../constants/navigation";
import {
  CONTACTS,
  ContactT,
  MAILTO_COMMERCIAL,
  MAILTO_PEC,
  OWNER_CONVERTED,
  TEL_DAVIDE,
  TEL_IVANO,
  TEL_SEGRETERIA,
} from "../../constants/contacts";
import Icon from "../ui/icon/icon";
import BoxIcon from "../ui/box-icon/box-icon";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useCookieBannerStore } from "../../store/cookieBannerStore";
// import { Fade } from "react-awesome-reveal";

import "./footer.scss";

const getContactHref = (contact: ContactT): string | undefined => {
  if (contact.type === "email" && contact.value) {
    return contact.value === "commerciale@rotoinfissioni.it"
      ? MAILTO_COMMERCIAL
      : MAILTO_PEC;
  }
  if (contact.type === "phone" && contact.value) {
    if (contact.owner === "segreteria") return TEL_SEGRETERIA;
    if (contact.owner === "davide") return TEL_DAVIDE;
    if (contact.owner === "ivano") return TEL_IVANO;
  }
  return undefined;
};

const Footer: React.FC = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile" || device === "tablet";
  const isSmartphone = device === "mobile";

  const { showCookieBanner } = useCookieBannerStore();

  const renderContactItem = (contact: ContactT, index: number) => {
    const label = `${contact.text}${
      contact.owner ? ` ${OWNER_CONVERTED[contact.owner]}` : ""
    }`;
    const href = getContactHref(contact);
    const content = (
      <>
        <Icon
          className="footer__contact-icon"
          name={contact.icon}
          size={"1rem"}
        />
        <span style={{ paddingTop: "0.125rem" }}>{label}</span>
      </>
    );

    if (href) {
      return (
        <a
          className="footer__contact-item"
          href={href}
          key={`${index}-${contact.text}`}
        >
          {content}
        </a>
      );
    }

    return (
      <div className="footer__contact-item" key={`${index}-${contact.text}`}>
        {content}
      </div>
    );
  };

  return (
    <footer className="footer" id="footer">
      {/* <Fade direction="up" duration={700} delay={0} triggerOnce> */}
      <div className="footer__info-section">
        <div className="footer__intro">
          <Link to={PATH.home}>
            <img src={Logo} alt="Rotoinfissioni" className="footer__logo-img" />
          </Link>
          {!isMobile ? (
            <span className="footer__p-iva">P.IVA: 04903730283</span>
          ) : null}
        </div>

        <div className="footer__contacts">
          <h3 className="footer__section-title">Contatti</h3>
          <div className="footer__contacts-list">
            {CONTACTS.map(renderContactItem)}
          </div>
        </div>

        <div className="footer__right">
          <div className="footer__legal">
            <h3 className="footer__section-title">Informazioni Legali</h3>
            <div className="footer__legal-link">
              <Link to={PATH.privacy}>
                <span>Privacy Policy</span>
              </Link>
              <Link to={PATH.cookie}>
                <span>Cookie Policy</span>
              </Link>
              <Link to={PATH.terms}>
                <span>Termini e Condizioni</span>
              </Link>
              <Link to={PATH.home} onClick={showCookieBanner}>
                Modifica le Preferenze Cookie
              </Link>
              <a
                href="/files/codice-etico-modello-rotoinfissioni.pdf"
                download="Codice Etico - Modello Rotoinfissioni.pdf"
                className="footer__download-link"
              >
                Codice Etico
              </a>
              <a
                href="/files/modello-231-parte-generale-rotoinfissioni.pdf"
                download="Modello di organizzazione, gestione e controllo (D.Lgs.
                231/2001) - Rotoinfissioni.pdf"
                className="footer__download-link"
              >
                Modello di organizzazione, gestione e controllo (D.Lgs.
                231/2001)
              </a>
            </div>
          </div>
          <div className="footer__social">
            <h3 className="footer__section-title">Seguici</h3>
            <div className="footer__social-btn">
              <a
                href="https://www.instagram.com/rotoinfissionisrl"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Rotoinfissioni"
              >
                <BoxIcon
                  icon="instagram"
                  size={!isSmartphone ? "small" : "medium"}
                  type="primary"
                  clickable
                />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61586756873308&locale=it_IT"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Rotoinfissioni"
              >
                <BoxIcon
                  icon="facebook"
                  size={!isSmartphone ? "small" : "medium"}
                  type="primary"
                  clickable
                />
              </a>
            </div>
          </div>
        </div>

        {!isMobile ? null : (
          <span className="footer__p-iva">P.IVA: 04903730283</span>
        )}
      </div>

      <div className="footer__reservation-section">
        <div className="footer__divider" />
        <span className="footer__all-reserved">
          ©{new Date().getFullYear()} Rotoinfissioni. Tutti i diritti riservati.
        </span>
      </div>
      {/* </Fade> */}
    </footer>
  );
};

export default Footer;
